<template>
  <!-- content(s) -->
  <div>
    <section>
      <ul class="eventList">
        <li v-for="(value, key) in eventList" :key="key">
          <template v-if="value.spEbProgress != 2">
            <a @click="eventDetail(value)" class="eventBnn">
              <span class="img">
                <img :src="value.spEbThumnail" alt="" />
              </span>
              <div class="info">
                <h2 class="titH4 medium">{{ value.spEbTitle }}</h2>
                <div class="desc">
                  <span class="term">{{ value.spEbSdate }} - {{ value.spEbEdate }}</span>
                  <span class="dDay">{{ value.restDays }}일 남음</span>
                </div>
              </div>
            </a>
          </template>

          <template v-else>
            <a class="eventBnn end">
              <span class="img">
                <img :src="value.spEbThumnail" alt="" />
              </span>
              <div class="info">
                <h2 class="titH4 medium">{{ value.spEbTitle }}</h2>
                <div class="desc">
                  <span class="term">{{ value.spEbSdate }} - {{ value.spEbEdate }}</span>
                  <span class="dDay">종료</span>
                </div>
              </div>
            </a>
          </template>
        </li>
      </ul>
    </section>
  </div>
  <!-- content(e) -->
  <!-- container(e) -->
</template>
<script>
// import QuickMenu from '@/views/app/comm/QuickMenu';
import ApiService from '@/common/api.service';

export default {
  name: 'eventMain',
  components: {
    // QuickMenu,
  },
  data: function () {
    return {
      eventList: [],
    };
  },
  created() {
    ApiService.service('GET', '/board/events')
      .then(({ data }) => {
        console.log(data);
        this.eventList = data.result;
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });
    //console.log(process.env);
  },
  methods: {
    eventDetail(value) {
      this.$router.push({ name: 'eventDetail', params: { idx: value.spEbIdx, title: value.spEbTitle, img: value.spEbThumnail } });
    },
    dateCal: function (ed) {
      let da1 = new Date();
      let edd = ed;
      let ar2 = edd.split('-');
      let da2 = new Date(ar2[0], Number(ar2[1]) - 1, ar2[2]);
      let dif = da2 - da1;
      let cDay = 24 * 60 * 60 * 1000; // 시 * 분 * 초 * 밀리세컨

      let re = Math.ceil(dif / cDay);
      let msg = '';
      if (re > 0) {
        msg = re + '일 남음';
      } else if (re == 0) {
        msg = 'd-day';
      } else {
        msg = '마감';
      }
      return msg;
    },
  },
};
</script>
